import { Group, Container, Image, Box, AppShell, Text } from '@mantine/core';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import classes from './farmer-layout.module.css';

import { precifieldLogoIcon } from '@assets';

interface FarmerLayoutProps {
  children: React.ReactNode;
}

export const FarmerLayout: FC<FarmerLayoutProps> = ({ children }) => {
  const { t } = useTranslation();
  return (
    <AppShell
      footer={{ height: 30 }}
      header={{ height: { base: 60 } }}
      padding="md"
    >
      <AppShell.Header>
        <Group bg="pf-green.6" flex="0 0 auto" h={60} pr="md">
          <Box className={classes.logoContainer}>
            <Image
              alt="Empreinte Logo"
              fit="contain"
              flex={1}
              h="100%"
              src={'/empreinte-logo.jpeg'}
            />
          </Box>
        </Group>
      </AppShell.Header>
      <AppShell.Main>
        <Container
          p={0}
          style={{
            flex: '1',
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
            width: '100%',
          }}
        >
          {children}
        </Container>
      </AppShell.Main>
      <AppShell.Footer bg="gray.1" px="md">
        <Group h="100%" justify="space-between">
          <Group gap="xs">
            <Image
              alt="Precifield logotype"
              flex={0}
              src={precifieldLogoIcon}
              w={30}
            />
            <Text c="dimmed" size="xs">
              {t('common.footer_mark')}
            </Text>
          </Group>
        </Group>
      </AppShell.Footer>
    </AppShell>
  );
};
